import axios from "axios";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import AssortmentManagement from "./screens/AssortmentManagementView";
import Login from "./screens/LoginView";
import Menu from "./screens/MenuView";
import Profile from "./screens/ProfileView";
import ResponseList from "./screens/ResponseListView";
import Scanner from "./screens/ScannerView";
import SignOrder from "./screens/SignView";
import Order from "./screens/SingleOrderView";

import { useDispatch, useSelector } from "react-redux";
import { identify } from "./services/identify/actions";
import RequireAuth from "./utils/requireAuth";
//Set Axios Defaults
axios.defaults.baseURL = "https://easyapp.bestelsysteem.net/api/"; //https://goeieete.suppliershub.eu/api/";

//moet anders
axios.defaults.headers.common["Authorization"] =
  "5ff3d38f-fdd1-448a-9370-0112d84c8b00";
// axios.defaults.headers.common["Token"] = "4b3b596e-1b5b-4026-9051-eb752f818d98";
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:3000';
axios.defaults.headers.common["Content-Type"] = "application/json";

//Add Every Axios Request and Response to Console // TEST ONLY
axios.interceptors.request.use((request) => {
  // console.log("Starting Request", request);
  return request;
});

axios.interceptors.response.use((response) => {
  // console.log("Response:", response);
  return response;
});

export default function App() {
  const dispatch = useDispatch();

  const identifyInfo = useSelector((state) => state.identify?.identifyInfo);

  useEffect(() => {
    //dispatch(identify("ruurhoeve.beukk.app"));
    dispatch(identify(window.location.hostname));
  }, []);

  if (!!!identifyInfo) {
    return <p>Loading...</p>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/menu"
          element={
            <RequireAuth>
              <Menu />
            </RequireAuth>
          }
        />
        <Route
          path="/response-list"
          element={
            <RequireAuth>
              <ResponseList />
            </RequireAuth>
          }
        />
        <Route
          path="/order"
          element={
            <RequireAuth>
              <Order />
            </RequireAuth>
          }
        />
        <Route
          path="/scanner"
          element={
            <RequireAuth>
              <Scanner />
            </RequireAuth>
          }
        />
        <Route
          path="/sign-order"
          element={
            <RequireAuth>
              <SignOrder />
            </RequireAuth>
          }
        />
        <Route
          path="/assortment-management/*"
          element={
            <RequireAuth>
              <AssortmentManagement />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

//TODO: requireAuth
// export default function App() {
//   return (
//     <HashRouter>
//       <Route exact path="/">
//         <Redirect to="/login" />
//       </Route>
//       <Route path="/Supplier" component={requireAuth(Su)} />
//       <Route path="/Hub" component={requireAuth(Hub)} />

//     </HashRouter>
//   );
// }
